<template>
	<!-- 成套设备 -->
	<div class="equipment">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick"></custom-table>
		<el-dialog :title="obj.title" :visible.sync="flag" width="60%">
			<div class="dialog-content">
				<ul>
					<li>
						<span>设备图片：</span>
						<img :src="$imgUrl + obj.pictureUrl" alt="" />
					</li>
					<li>
						<span>产品标题：</span>
						{{ obj.title }}
					</li>
					<li>
						<span>提供人姓名：</span>
						{{ obj.userName }}
					</li>
					<li>
						<span>设备类型：</span>
						{{ obj.typeName }}
					</li>
					<li>
						<span>设备容量：</span>
						{{ obj.volume }}
					</li>
					<li>
						<span>设备电压：</span>
						{{ obj.voltage }}
					</li>
					<li>
						<span>设备地址：</span>
						{{ obj.provinceName }}-{{ obj.cityName }}-{{ obj.countyName }}
					</li>
					<li>
						<span>租赁价格（3月）：</span>
						¥{{ obj.priceGears.price }}
					</li>
					<li>
						<span>租赁价格（6月）：</span>
						¥{{ obj.priceGears.price1 }}
					</li>
					<li>
						<span>租赁价格（9月）：</span>
						¥{{ obj.priceGears.price2 }}
					</li>
					<li>
						<span>租赁价格（12月）：</span>
						¥{{ obj.priceGears.price3 }}
					</li>
					<li>
						<span>箱变价格：</span>
						¥{{ obj.priceGears.xbxl }}
					</li>
					<li>
						<span>架空线路：</span>
						¥{{ obj.priceGears.jkxl }}
					</li>
					<li>
						<span>电缆线路：</span>
						¥{{ obj.priceGears.dlxl }}
					</li>
					<li>
						<span>单杆：</span>
						¥{{ obj.priceGears.dgxl }}
					</li>
				</ul>
				<!-- <el-button type="primary" @click="flag = false">关闭</el-button> -->
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		equipmentList,
		equipmentDelete,
		equipmentDetail
	} from '../../http/factory/add-eme.js';
	export default {
		name: 'equipment',
		data() {
			return {
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 12,
					currentPage: 1
				},
				multipleSelection: [],
				buttonGroup: [{
					type: 'primary',
					size: 'mini',
					plain: true,
					icon: 'el-icon-plus',
					word: '添加商品',
					sign: 'new'
				}],
				filterValue: {
					keyword: ''
				},
				tableFilter: [{
					prop: 'keyword',
					type: 'el-input',
					placeholder: '请输入关键词',
					size: 'small'
				}],
				tableConfig: {
					selection: true,
					stripe: true,
					tableHeader: [{
							prop: 'title',
							label: '方案信息',
							width: 400
						},
						{
							prop: 'addTime',
							label: '上传时间',
							width: 230
						},
						{
							prop: 'price',
							label: '价格',
							width: 150
						}
					],
					tableEvent: [{
							icon: 'el-icon-search',
							name: '查看',
							color: 'green',
							sign: 'check'
						},
						{
							icon: 'el-icon-edit',
							name: '修改',
							color: 'blue',
							sign: 'edit'
						},
						{
							icon: 'el-icon-delete',
							name: '删除',
							color: 'red',
							sign: 'delete'
						}
					],
					emptyDescription: '当前没有数据'
				},
				tableData: [],
				flag: false,
				obj: {
					pictureUrl: '',
					title: '',
					userName: '',
					typeName: '',
					volume: '',
					voltage: '',
					provinceName: '',
					cityName: '',
					countyName: '',
					priceGears: {
						price: '',
						price1: '',
						price2: '',
						price3: '',
						xbxl: '',
						jkxl: '',
						dlxl: '',
						dgxl: ''
					}
				}
			};
		},
		methods: {
			// 页面变化
			pageChange() {
				this.fetchData();
			},
			// 右上按钮
			buttonClick(sign) {
				if (sign === 'new') {
					this.$router.push({
						path: '/factoryUser/factoryEquAdd'
					});
				}
			},
			// 筛选条件变化
			filterChange() {
				this.fetchData()
			},
			// 操作按钮
			scopeButtonClick(row, sign) {
				if (sign === 'edit') {
					this.$router.push({
						path: '/factoryUser/factoryEquAdd',
						query: {
							id: row.id
						}
					});
				}
				if (sign === 'delete') {
					this.deleteEqu(row);
				}
				if (sign === 'check') {
					this.checkEqu(row);
				}
			},
			// 删除设备
			deleteEqu(row) {
				this.$confirm('确认删除这个设备吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						equipmentDelete({
							serviceType: 0,
							id: row.id
						}).then(res => {
							this.$message({
								message: '删除设备成功',
								type: 'success'
							});
							this.fetchData();
						});
					})
					.catch(() => {});
			},
			// 获取设备列表
			fetchData() {
				equipmentList({
					serviceType: 0,
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage,
					title: this.filterValue.keyword
				}).then(res => {
					let list = res.rows;
					let array = new Array();
					for (let i = 0; i < list.length; i++) {
						let obj = {
							title: list[i].title,
							addTime: list[i].addTime,
							price: list[i].priceGears.price,
							id: list[i].id
						};
						array.push(obj);
					}
					this.tableData = array;
					this.pageConfig.total = res.total;
				});
			},
			// 查看设备详情
			checkEqu(row) {
				equipmentDetail({
					serviceType: 0,
					id: row.id
				}).then(res => {
					this.obj = res;
					this.flag = true;
				});
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData();
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.equipment {
		width: 100%;
		height: 810px;
		background: @vue-bg-color;
	}

	.dialog-content {
		width: 100%;

		ul {
			width: 100%;

			li {
				width: 100%;
				line-height: 40px;
				display: flex;
				align-items: center;

				img {
					width: 200px;
				}

				span {
					color: @vue-text-color-grey;
				}
			}
		}
	}
</style>
